
import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';

@Component({
  standalone: false,
  selector: 'manage-gcm-dialog',
  templateUrl: './manage-gcm-dialog.component.html',
  styleUrls: ['./manage-gcm-dialog.component.css']
})

export class ManageGcmDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  invalidInput: boolean = false;
  errorMessage: string = '';
  formGroup1: any;
  regions: any = [];
  regionsFinal: any = [];
  filteredRegions: any = [];

  constructor(
    public dialogRef: MatDialogRef<ManageGcmDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
  }

  ngOnInit(): void {

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.formGroup1 = this._formBuilder.group({
      regionCtrl: [{ value: this.local_data.element.region.name, disabled: true }],
      gcmCtrl: [{ value: this.local_data.element.gcm, disabled: true }],
      costCtrl: [this.local_data.element.cost, Validators.required]
    });

  }

  filterRegions() {
    let search = this.formGroup1.get('regionsFilterCtrl').value;
    if (!search) {
      this.filteredRegions = (this.regions.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredRegions = this.regions.filter((region: any) => region.name.toLowerCase().indexOf(search) > -1);
  }

  doAction() {
    const formGroup = this.formGroup1.value;
    let valid = true;

    if (!formGroup.costCtrl) {
      this.invalidInput = true;
      this.errorMessage = this.variables.errorCostEmpty;
      valid = false;
    }
    else if (formGroup.costCtrl < 0) {
      this.invalidInput = true;
      this.errorMessage = this.variables.errorCostValue;
      valid = false;
    }
    else {
      this.invalidInput = false;
    }

    //Pass data
    if (valid) this.dialogRef.close({ data: formGroup.costCtrl });
  }

}
